import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { SettingsProvider } from "@/context/SettingsContext";
import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import AddSlipPage from "@/pages/AddSlipPage";
import SlipDetailPage from "@/pages/SlipDetailPage";
import HistoryPage from "@/pages/HistoryPage";
import AuthCallback from "@/pages/AuthCallback";
import SettingsPage from "@/pages/SettingsPage";
import NotificationsHistoryPage from "@/pages/NotificationsHistoryPage";
import WelcomePage from "@/pages/WelcomePage";
import { Toaster } from "@/components/ui/sonner";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen bg-[#0A0D14] text-slate-400 flex items-center justify-center text-xs uppercase tracking-widest">Loading...</div>;
  if (!user) return <Navigate to="/welcome" replace />;
  return <SettingsProvider userId={user.user_id}>{children}</SettingsProvider>;
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/welcome" element={<WelcomePage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/dashboard" element={<Protected><DashboardPage /></Protected>} />
      <Route path="/add" element={<Protected><AddSlipPage /></Protected>} />
      <Route path="/history" element={<Protected><HistoryPage /></Protected>} />
      <Route path="/slip/:slip_id" element={<Protected><SlipDetailPage /></Protected>} />
      <Route path="/settings" element={<Protected><SettingsPage /></Protected>} />
      <Route path="/notifications" element={<Protected><NotificationsHistoryPage /></Protected>} />
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
          <Toaster theme="dark" position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
